












































































































































































































































































































































import Vue from "vue";
import { $eventsBus } from "@/main";
import EndCardLayersSettings from "@/app/modules/work/components/content-cotainer/tools-panel-controllers/TheContentContainerToolsPanelEndCardController/EndCardLayersSettings.vue";
import BaseSimpleSlider from "@/app/shared/components/base/BaseSimpleSlider.vue";
import BaseInputEasy from "@/app/shared/components/base/BaseInputEasy.vue";
import BaseInputEasySlider from "@/app/shared/components/base/BaseInputEasySlider.vue";
import BaseButton from "@/app/shared/components/base/BaseButton.vue";
import BaseInput from "@/app/shared/components/base/BaseInput.vue";
import BaseAnimation from "@/app/shared/components/base/BaseAnimation.vue";
import BaseColorpicker from "@/app/shared/components/base/BaseColorpicker.vue";
import BaseInputCircleColor from "@/app/shared/components/base/BaseInputCircleColor.vue";
import BaseToggleSwitch from "@/app/shared/components/base/BaseToggleSwitch.vue";
import BaseLabeledSwitch from "@/app/shared/components/base/BaseLabeledSwitch.vue";
import { VPopover, VClosePopover } from "v-tooltip";
import motionAlpha from "@/assets/animation/motion_alpha.json";
import motionCut from "@/assets/animation/motion_cut.json";
import motionDownBlur from "@/assets/animation/motion_down_blur.json";
import motionDown from "@/assets/animation/motion_down.json";
import motionLeftBlur from "@/assets/animation/motion_left_blur.json";
import motionLeft from "@/assets/animation/motion_left.json";
import motionRightBlur from "@/assets/animation/motion_right_blur.json";
import motionRight from "@/assets/animation/motion_right.json";
import motionUpBlur from "@/assets/animation/motion_up_blur.json";
import motionUp from "@/assets/animation/motion_up.json";

export default Vue.extend({
  name: "EndCardController",
  components: {
    EndCardLayersSettings,
    BaseSimpleSlider,
    BaseButton,
    BaseInputEasy,
    BaseInputEasySlider,
    BaseInput,
    BaseAnimation,
    BaseColorpicker,
    BaseInputCircleColor,
    BaseToggleSwitch,
    BaseLabeledSwitch,
    VPopover,
  },
  directives: {
    "close-popover": VClosePopover,
  },
  data: function () {
    return {
      endCardVolume: 100,
      hoverId: null,
      transitions: [
        { id: 0, name: "Cut", file: motionCut },
        { id: 1, name: "Alpha", file: motionAlpha },
        { id: 2, name: "Motion Left", file: motionLeft },
        { id: 3, name: "Motion Right", file: motionRight },
        { id: 4, name: "Motion Right Blur", file: motionRightBlur },
        { id: 5, name: "Motion Left Blur", file: motionLeftBlur },
        { id: 6, name: "Motion Up", file: motionUp },
        { id: 7, name: "Motion Down", file: motionDown },
        { id: 8, name: "Motion Up Blur", file: motionUpBlur },
        { id: 9, name: "Motion Down Blur", file: motionDownBlur },
      ],
      hoverBlock: "",
    };
  },
  props: {
    isMultiSelectMode: {
      type: Boolean,
    },
  },
  computed: {
    items: function () {
      return this.$store.state.items;
    },
    previewItem: function () {
      return this.$store.state.selectedItem;
    },
    isLoadingPackshot: function () {
      if (!this.previewItem.currentVariation.checked) {
        return this.previewItem.currentVariation.isLoadingPackshot;
      } else {
        return this.items.some((i) => {
          return i.variations.some((v) => {
            return v.checked && v.isLoadingPackshot;
          });
        });
      }
    },
  },
  watch: {
    /*     previewItem: {
      deep: true,
      handler() {
        this.endCardVolume = this.previewItem
          ? Math.round(this.previewItem.currentVariation.endCard.volume * 100)
          : 100;
      },
    },
    endCardVolume: function () {
      if (this.previewItem) {
        this.previewItem.currentVariation.endCard.volume =
          this.endCardVolume / 100;
      }
    }, */
    "previewItem.currentVariation.endCard": function () {
      this.$forceUpdate();
    },
  },
  mounted() {},
  methods: {
    updateAnimationPackshot(endCard) {
      $eventsBus.$emit("updateAnimationPackshot", endCard);
    },
    isHoverBlock(blockId) {
      return this.hoverBlock === blockId;
    },
    onMouseOverBlock(blockId) {
      this.hoverBlock = blockId;
    },
    onMouseLeaveBlock() {
      this.hoverBlock = "";
    },
    clearEndCard() {
      this.previewItem.currentVariation.endCard.packshot = null;
      this.previewItem.currentVariation.recalcFileOutputParameters();
      $eventsBus.$emit("updatePackshotAfterChanges");
      this.changeCheckedItems({ isPackshot: true });
    },
    openEndCardLibraryWindow() {
      this.$store.commit("showEndCardLibraryWindow", true);
    },

    switchBlock(val, endCard, block) {
      endCard.switchBlock(val, block);

      this.updateAnimationPackshot(endCard);

      this.changeCheckedItems({
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.switchBlock(val, block);
        },
      });
    },
    switchGroup(group, block, endCard) {
      if (group.switch.type === "default") {
        block.groups.forEach((g) => {
          if (g.switch.type === "recalculable") {
            endCard.switchGroup(0, g);

            this.changeCheckedItems({
              callbackChangeAnimationCheckedItems: (twinEndCard) => {
                twinEndCard.switchGroup(0, g);
              },
            });

            this.saveModifiedValues(0, "switch", null, g, block, endCard);
          }
        });
      }
      if (group.switch.type === "recalculable") {
        const checkedGroup = block.groups.find((g) => g === group);
        endCard.switchGroup(100, checkedGroup);

        this.changeCheckedItems({
          callbackChangeAnimationCheckedItems: (twinEndCard) => {
            twinEndCard.switchGroup(100, checkedGroup);
          },
        });

        this.saveModifiedValues(
          100,
          "switch",
          null,
          checkedGroup,
          block,
          endCard
        );

        block.groups
          .filter((g) => g !== group)
          .forEach((g) => {
            if (g.switch.type === "recalculable") {
              endCard.switchGroup(0, g);

              this.changeCheckedItems({
                callbackChangeAnimationCheckedItems: (twinEndCard) => {
                  twinEndCard.switchGroup(0, g);
                },
              });

              this.saveModifiedValues(100, "switch", null, g, block, endCard);
            }
          });
      }

      this.updateAnimationPackshot(endCard);
    },
    checkSelectGroup(groups, group, endCard) {
      const hasRecalculableActiveGroups = groups.some(
        (g) =>
          g.switch.type === "recalculable" &&
          endCard.getAnimationPropAtPath(g.switch.path) === 100
      );
      if (hasRecalculableActiveGroups) {
        return (
          group ===
          groups.find(
            (g) =>
              g.switch.type === "recalculable" &&
              endCard.getAnimationPropAtPath(g.switch.path)
          )
        );
      } else {
        return group === groups.find((g) => g.switch.type === "default");
      }
    },
    saveModifiedValues(val, key, layer, group, block, endCard) {
      endCard.saveModifiedValues(val, key, layer, group, block);

      this.changeCheckedItems({
        callbackChangeAnimationCheckedItems: (twinEndCard) => {
          twinEndCard.saveModifiedValues(val, key, layer, group, block);
        },
      });
    },
    changeCheckedItems(optionsToChange) {
      if (!this.previewItem.currentVariation.checked) {
        return;
      }
      this.items.forEach((item) => {
        item.variations.forEach((v) => {
          if (!v.checked || v === this.previewItem.currentVariation) {
            return;
          }

          if (!!optionsToChange.isTransition) {
            v.endCard.transitionStyleId =
              this.previewItem.currentVariation.endCard.transitionStyleId;
          }
          if (!!optionsToChange.isPackshot) {
            v.endCard.packshot =
              this.previewItem.currentVariation.endCard.packshot;
            v.recalcFileOutputParameters();
          }

          if (!!optionsToChange.callbackChangeAnimationCheckedItems) {
            if (
              v.endCard.packshot &&
              v.endCard.getType() === "template-default" &&
              v.endCard.packshot.packId ===
                this.previewItem.currentVariation.endCard.packshot.packId &&
              v.endCard.packshot.model.id ===
                this.previewItem.currentVariation.endCard.packshot.model.id
            ) {
              optionsToChange.callbackChangeAnimationCheckedItems(v.endCard);
            }
          }
        });
      });
    },
    isTransitionSelected(id) {
      return id === this.previewItem.currentVariation.endCard.transitionStyleId;
    },
    isTransitionHover(id) {
      return id === this.hoverId;
    },
    onMouseOver(id) {
      this.hoverId = id;
    },
    onMouseLeave() {
      this.hoverId = null;
    },
    selectTransition(id) {
      this.previewItem.currentVariation.endCard.transitionStyleId = id;
      this.changeCheckedItems({ isTransition: true });
    },
    loadTransitions() {
      this.axios
        .post(
          "/packshots/getTransition",
          {
            sessionId: this.$store.state.userInfo.sessionId,
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          this.transitions = response.data.list;
        });
    },
  },
});
